import { render } from "./estimation.vue?vue&type=template&id=62836c3d&ts=true"
import script from "./estimation.vue?vue&type=script&lang=ts"
export * from "./estimation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__